<template>
  <div class="page-width-cart">
    <!-- Mobile -->
    <div v-if="this.isMobile" class="cart-mobile">
      <div class="mobile-cart-header">
          <div class="zip_container"  v-if="shippingMethodGlobal === 'Delivery'">
            <div class="white">
              <img src="../assets/img/pin.svg" />
              <p class="white_txt">Delivery to {{userZip}}</p>
            </div>
            <div class="black">
              <p class="white_txt">Today</p>
              <img src="../assets/img/clock.svg" />
            </div>
          </div>
           <div class="zip_container"  v-if="shippingMethodGlobal === 'Pickup'">
            <div class="white" @click="setLocation(true)">
              <img src="../assets/img/pin.svg" />
              <p class="white_txt" v-if="this.warehouseLocation && this.warehouseLocation !== 'All'">{{this.warehouseLocation}}</p>
              <p class="white_txt" v-else >{{ $t('select_store') }}</p>
            </div>
            <div class="black">
              <p class="white_txt">Today</p>
              <img src="../assets/img/clock.svg" />
            </div>
          </div>
          <p v-if="shippingMethodGlobal === 'Delivery'" class="shipping-note">Free Shipping</p>
      </div>
      <div class="cart-items-container">
        <ul class="cart-items"  v-if="loggedIn">
          <li class="cart-card" v-for="(item, index) in this.cartProductsList.Sales_Order_Lines" :key="item.Product_id"
          >
            <div class="image-content">
              <div class="image-foundation">
                <img class="cart-image" :src="item.Thumbnail" />
              </div>
            </div>

            <div class="info-content">
              <div class="cart-product-name">
                {{curIsEnglish ? item.Name : item.Description}}
              </div>
              <div class="cart-product-price">${{item.Price}}</div>
              <div class="mobile-btn">
                <button class="mobile-cart-btn" @click="deleteItem(item)" >Delete</button>
                <button class="mobile-cart-btn">Save for Later</button>
              </div>
            </div>
            <div class="quantity-container">
                <div class="quantity-box">
                  <button @click="updateItemCount($event, item)" class="quantity-button">-</button>
                  <p class="curr-quantity">{{item.Quantity}}</p>
                  <button @click="throttleAddToCart(item)" class="quantity-button">+</button>
                </div>
            </div>
          </li>
        </ul>
        <ul class="cart-items"  v-else>
          <div class="cart-info-container">
            <p class="product-wide">Product</p>
            <p class="product-short">Unit Price</p>
            <p class="product-short">Quantity</p>
            <p class="product-short">Total</p>
          </div>
          <li class="cart-card"  v-for="(item, index) in this.cartProductsList" :key="item.Product_id"
          >
            <div class="image-content">
              <div class="image-foundation">
                <img class="cart-image" :src="item.Thumbnail" />
              </div>
            </div>
            <div class="inner-content">
              <div class="cart-product-name">
                {{curIsEnglish ? item.Name : item.Description}}
              </div>
            </div>
            <div class="inner-content">
              <div class="cart-product-price">${{item.Price}}</div>
            </div>
            <div class="quantity-container">
              <div class="quantity-box">
                <button @click="updateItemCount($event, item)" :class="item.quantity === 1 ? 'quantity-button-one' : 'quantity-button'">-</button>
                <p class="curr-quantity">{{item.quantity}}</p>
                <button @click="throttleAddToCart(item)" class="quantity-button">+</button>
              </div>
            </div>
            <div class="main-price-container">
             <span class="main-price">${{(item.Price * item.quantity).toFixed(2)}}</span>
            </div>
              <img src="../assets/img/times.svg" @click="deleteItem(item)" style="cursor: pointer"/>
          </li>
        </ul>
      </div>
      <button class="checkout-mobile">Checkout | ${{this.calculateLocalSubtotal()}}</button>
    </div>
    <div v-else>
      <div class="cart-items-container">
        <h2 class="my-cart">{{ $t('myCart')}}</h2>
        <ul class="cart-items"  v-if="loggedIn">
          <div class="cart-info-container">
            <p class="product-wide">{{ $t('product') }}</p>
            <p class="product-short">{{$t('unit_price')}}</p>
            <p class="product-short">{{ $t('quantity') }}</p>
            <p class="product-short">{{ $t('total') }}</p>
          </div>
          <li class="cart-card" v-for="(item, index) in this.cartProductsList.Sales_Order_Lines" :key="item.Product_id"
          >
            <div class="image-content">
              <div class="image-foundation">
                <img class="cart-image" :src="item.Thumbnail" />
              </div>
            </div>
            <div class="inner-content">
              <div class="cart-product-name">
                {{curIsEnglish ? item.Name : item.Description}}
              </div>
            </div>
            <div class="inner-content">
              <div class="cart-product-price">${{item.Price}}</div>

            </div>
            <div class="quantity-container">
                <div class="quantity-box">
                  <button @click="updateItemCount($event, item)" :class="item.Quantity === 1 ? 'quantity-button-one' : 'quantity-button'">-</button>
                  <p class="curr-quantity">{{item.Quantity}}</p>
                  <button @click="throttleAddToCart(item)" class="quantity-button">+</button>
                </div>
            </div>
            <div class="main-price-container">
             <span class="main-price">${{(item.Price * item.Quantity).toFixed(2)}}</span>
            </div>
              <img src="../assets/img/times.svg" @click="deleteItem(item)" style="cursor: pointer"/>
          </li>
        </ul>
        <ul class="cart-items"  v-else>
          <div class="cart-info-container">
            <p class="product-wide">Product</p>
            <p class="product-short">Unit Price</p>
            <p class="product-short">Quantity</p>
            <p class="product-short">Total</p>
          </div>
          <li class="cart-card"  v-for="(item, index) in this.cartProductsList" :key="item.Product_id"
          >
            <div class="image-content">
              <div class="image-foundation">
                <img class="cart-image" :src="item.Thumbnail" />
              </div>
            </div>
            <div class="inner-content">
              <div class="cart-product-name">
                {{curIsEnglish ? item.Name : item.Description}}
              </div>
            </div>
            <div class="inner-content">
              <div class="cart-product-price">${{item.Price}}</div>
            </div>
            <div class="quantity-container">
                <div class="quantity-box">
                  <button @click="updateItemCount($event, item)" :class="item.quantity === 1 ? 'quantity-button-one' : 'quantity-button'">-</button>
                  <p class="curr-quantity">{{item.quantity}}</p>
                  <button @click="throttleAddToCart(item)" class="quantity-button">+</button>
                </div>
            </div>
            <div class="main-price-container">
             <span class="main-price">${{(item.Price * item.quantity).toFixed(2)}}</span>
            </div>
              <img src="../assets/img/times.svg" @click="deleteItem(item)" style="cursor: pointer"/>
          </li>
        </ul>
      </div>
      <div class="price-cart">
        <div class="coupon-container">
          <div class="coupon-bar">
            <p>{{ $t('coupon') }}</p>
            <div
            class="input-container"
            :class="{'promo-code-not-valid':promoCodeError || promoCodeValid}"
            v-if="!promoCodeSuccessful">
              <couponAutocomplete class="coupon-input" v-model="promoCode"></couponAutocomplete>
              <button @click="validatePromotionCode($event)">{{ $t('apply_afm') }}</button>
            </div>
            <div v-if="!promoCodeSuccessful" class="not-valid">
              {{ notValid }}
            </div>
            <div class="applied-promo" v-else>
              <div class="promo-body">
                <p>{{this.promoCode}}</p>
                <p>{{ $t('applied') }}</p>
              </div>
              <button @click="resetPromotionCode($event)" class="change-promo">{{ $t('change') }}</button>
            </div>
          </div>
          <div class="subtotal-container">
            <p class="subtotal">{{ $t('subtotal_afm') }} ({{itemCount}} {{ $t('items') }}):</p>
            <p class="subtotal-cost">${{this.calculateLocalSubtotal()}}</p>
          </div>
        </div>
        <div class="cart-totals">
          <div class="totals">
            <div class="num-container">
              <p class="num-title">{{ $t('discount_afm') }}</p>
              <p class="num-total">-${{this.Savings.toFixed(2)}}</p>
            </div>
            <div class="num-container">
              <p class="num-title">{{ $t('total_afm') }}</p>
              <p class="num-total">${{this.calculateLocalSubtotal()}}</p>
            </div>
          </div>
          <div class="checkout-container">
            <button :class="disableCheckoutButton() ? 'checkout-disabled' : 'checkout' " @click="postCartItemsAndCheckout($event)">
              {{ $t('continue_to_checkout') }}</button>
            <div class="checkout-blurb-container">
              <p class="checkout-blurb">{{ $t('same_day_delivery') }}</p>
              <p class="checkout-blurb">{{ $t('out_of_stock_tip') }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- category 2 products -->
      <div class="page-width">
        <pcRecommended></pcRecommended>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import _ from 'lodash';
import productCard from "./productCard";
import pcRecommended from "../components/pc-recommended/pc-recommended";
import couponAutocomplete from "../components/coupon-autocomplete/coupon-autocomplete";

import {
  isUserAuthenticated,
  setLocalCart,
} from "../store/modules/cart";
import {locales, promoCodeList} from "../mixin";

export default {
  name: "cart",
  mixins: [promoCodeList, locales],
  components: {
    productCard,
    pcRecommended,
    couponAutocomplete
  },
  methods:  {
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    ...mapActions('checkout', ['validatePromoCode']),
    ...mapMutations('cart', ['stopAddToCartLoading']),
    ...mapActions('cart',['addProductToCart']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapMutations('navbar', ['toggleLoginModalVisibility', 'toggleRegisterModalVisibility', 'toggleWarehouseSelectionModalVisibility']),
    setLocation() {
      this.toggleWarehouseSelectionModalVisibility(true);
    },
    goToLogin() {
      this.toggleLoginModalVisibility(true);
      // this.$router.push('/login');
    },
    checkAuthentication(authCallback) {
      this.isAuthenticated = isUserAuthenticated(), authCallback;
    },
    async validatePromotionCode(e) {
      e.preventDefault();
      let totalPrice = this.cartProductsList && this.cartProductsList.TotalPrice;
      const isSuccess = await this.validatePromoCode([this.promoCode, totalPrice]);
      !isSuccess && (this.promoCode = '')
    },
    resetPromotionCode(e) {
      e.preventDefault();
      this.clearPromoCode();
      this.promoCode = '';
    },
    deleteItem(item) {
      if (!this.itemDeletedLoading) {
        let productId = item.Product_id;
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/deleteCartItem', item.Product_id)
          .then(() => {
            this.$store.dispatch('cart/getCart');
          });
        } else {
          const cartItems = _.filter(this.$store.state.cart.cartProductsList, item => item.Product_id !== productId);
          setLocalCart(cartItems);
          let itemCount = 0;
          cartItems.forEach((item) => {
            itemCount += item.quantity;
          });
          this.$store.dispatch('cart/updateItemQuantity', [productId, itemCount]);
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
  updateItemCount(e, item) {
    e.preventDefault();
      if (isUserAuthenticated()) {
      let quantity = item.Quantity - 1;
      if (quantity < 1) {
        this.deleteItem(item);
      } else {
        this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
        .then(() => {
          this.local = false;
          this.$store.dispatch('cart/getCart');
        });
      }
    } else {
      item.quantity = item.quantity - 1;
      if (item.quantity < 1) {
        this.deleteItem(item)
      }
      this.$store.dispatch('cart/updateLocalCart', item)
      .then(() => {
        this.local = true;
        this.$store.dispatch('cart/fetchCartProducts');
      })
    }
  },
    postCartItemsAndCheckout(e) {
      e.preventDefault();
      if (!localStorage.getItem('warehouseLocationWeb')) {
        this.toggleWarehouseSelectionModalVisibility(true);
        return;
      }
      if (isUserAuthenticated()) {
        if (this.$store.state.cart.cartProductsList &&  this.$store.state.cart.cartProductsList.Sales_Order_Lines.length > 0) {
          const cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.ShippingMethod = "Delivery";
          cartItems.Tip = 0;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
          cartItems.PromoCode = this.promoCode;
          this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
          .then(() => {
            this.$router.push('/purchase');
          });
        }
      } else {
        this.toggleLoginModalVisibility(true);
        // this.$router.push('/login');
      }
    },
    localTotalPrice(price, quantity) {
      return (price * quantity).toFixed(2);
    },
    handleCartProductImageClick(productNum) {
      this.$router.history.push(`/productdetails?productnum=${productNum}`);
    },
    disableCheckoutButton() {
      if (isUserAuthenticated()) {
        if (this.cartProductsList.Sales_Order_Lines &&    !this.cartProductsList.Sales_Order_Lines.length) {
          return true;
        }
      } else {
        if (!this.cartProductsList.length) {
          return true
        }
      }
      return false;
    },
    calculateLocalSubtotal() {
      if (!this.loggedIn) {
        let cost = 0;
         this.$store.state.cart.cartProductsList.map(item => {
          let itemPrice = item.Price * item.quantity;
          cost += itemPrice;
        })
        return cost.toFixed(2);
      } else {
        return (this.$store.state.cart.cartProductsList.TotalPrice - this.Savings).toFixed(2);
      }
    },
    calculateTotalCartQuantity() {
      let totalQuantity = 0;
      for (var i = 0; i < this.cartProductsList.length; i++) {
        totalQuantity += this.cartProductsList[i].quantity;
      }
      return totalQuantity;
    },
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
      .then(() => {
        this.$store.dispatch('cart/getCart');
      });
    },
    handleAddToCartFail(product) {
      this.stopAddToCartLoading();
      if (localStorage.Lang === 'ch') {
        alert( this.$t('stock_msg_1') + `${product.Name}` +  this.$t('stock_msg_2'));
      } else {
        alert(`Sorry, there are only ${product.InventoryQuantity} available of ${product.Name}`);
      }
    },
    throttleAddToCart:  _.debounce(function(item, event) {
      this.addToCart(item)
    }, 150, {'leading': true, 'trailing': true}),
    addToCart: function(item) {
       if (!localStorage.getItem('warehouseLocationWeb')) {
        this.toggleWarehouseSelectionModalVisibility(true);
        return;
      }
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item, event: event})
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])
        }
      }
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({
        name: 'productDetails',
        query: { productNum: product.ProductNum
      }})
      }
  },
  beforeRouteLeave(to, from, next) {
      if (isUserAuthenticated()) {
      this.$store.dispatch('cart/getCart')
      .then(() => {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
      cartItems.PromoCode = this.promoCode;
       this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
       .then(() => {
         this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
       })
      })
    }
      this.clearPromoCode();
      this.clearCard();
      next();
  },
  data(){
    return{
      addressList: [],
      deliveryDate: undefined,
      deliveryTime: undefined,
      willCallLocation: undefined,
      warehouseList: [],
      billingAddressOpen: false,
      creditCardOpen: false,
      customerNote: '',
      orders: [],
      unpaidAmount: undefined,
      isBlocking: true,
      isCreditUsed: false,
      isLoadingWarehouseList: false,
      isLoadingAddressList: false,
      isLoadingSubmitOrder: false,
      pickUpTime: '',
      isAddressBookOpen: false,
      stepIndex: 0,
      width: 0,
      validatedPromoCode: undefined,
      promoCode: '',
      promoCodeIsValid: false,
      promoCodeMessage: '',
      isValidatingPromoCode: false,
      isCashAllowed: false,
      bypass: null,
      local: null,
      productSwiper: {
        slidesPerView: 5,
        navigation: {
          nextEl: '.swiper-button-next.swp1',
          prevEl: '.swiper-button-prev.swp1',
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          //when width >= 480
          480:{
            slidesPerView: 2,
          },
          767: {
            slidesPerView: 2,
          },
          //when width >= 640
          990: {
            slidesPerView: 3,
          },
          1200:{
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
          }
        }
      },
    }
  },
  beforeMount() {
    if (isUserAuthenticated()) {
      this.local = false;
      this.$store.dispatch('cart/getCart');
    } else {
      this.local = true;
      this.$store.dispatch('cart/fetchCartProducts');
    }
  },
  mounted() {
    // recommended for you会在刷新的时候清空，所以需要调用一下
    this.$store.dispatch('products/fetchCustomCategories',{company_id: 1,warehouse_id: 1});
  },
  activated() {
    this.promoCode && this.validatePromotionCode({preventDefault:function () {}})
    localStorage.removeItem('beforeRefreshPromoCode')
    localStorage.removeItem('promo-code')
  },
  computed: {
    ...mapState({
      cartProductsList: state => state.cart.cartProductsList,
      token: state => state.auth.token,
      loggedIn: state => state.auth.loggedIn,
      itemCount: state => state.cart.itemCount,
      necessaryCartItems: state => state.cart.necessaryCartItems,
      mobile: state => state.cart.mobile,
      itemDeletedLoading: state => state.cart.itemDeletedLoading,
      addToCartLoading: state => state.cart.addToCartLoading,
      TotalPrice: state => state.checkout.TotalPrice,
      promoCodeSuccessful: state => state.checkout.promoCodeSuccessful,
      promoCodeError: state => state.checkout.promoCodeError,
      promoCodeValid: state => state.checkout.promoCodeValid,
      promoCodeValid_ch: state => state.checkout.promoCodeValid_ch,

      Savings: state => state.checkout.Savings,
      windowWidth: state => state.navbar.windowWidth,
      warehouseLocation: state => state.navbar.warehouseLocation,

      isMobile() {
        return this.windowWidth < 800;
      },
      userZip: state => state.navbar.userZip,
      shippingMethodGlobal: state => state.navbar.shippingMethodGlobal,
    }),
    notValid({promoCodeError, curIsChinese, promoCodeValid, promoCodeValid_ch}) {
      if (promoCodeError) return promoCodeError
      if (curIsChinese && promoCodeValid_ch) return promoCodeValid_ch
      return promoCodeValid
    }
  },
  watch: {
    token: function(newVal, oldVal) {
      immediate: true;
      if (newVal !== null || newVal !== undefined) {
        this.local = false;
         this.$store.dispatch('cart/getCart');
      } else {
        this.local = true;
        this.$store.dispatch('cart/fetchCartProducts');
      }
    },
    itemCount: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/getCart');
        } else {
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/cart.less";
</style>



// WEBPACK FOOTER //
// src/view/cart.vue